var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment",
      attrs: { id: "warehouse-canceled-register-payment-method-page" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "payment-content" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "m-t-xl m-b-xl" }, [
          _vm._v(
            "\n      ご利用になる場合は、倉庫管理画面よりお手続きをお願いいたします。\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box-link-to-warehouse m-b-lg" },
          [
            _c(
              "router-link",
              {
                staticClass: "link-to-warehouse",
                attrs: { to: "/Warehouses" }
              },
              [_vm._v("倉庫管理はこちら")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", { staticClass: "payment-title" }, [
        _vm._v("お支払い方法の登録をキャンセルしました。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("\n      お手続きありがとうございます。"),
      _c("br"),
      _vm._v(
        "\n      セラー様の操作により、お支払い方法の登録をキャンセルしました。\n    "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07ba5bcd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ba5bcd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouses/CanceledRegisterPaymentMethod.vue
// module id = null
// module chunks = 